export const AUTOBID_STATUS = {
  NOT_EXECUTED: 0,
  BID_EXECUTED: 1,
  BID_EXCEEDED: 2,
  BID_NOT_EXECUTED: 3,
  DISABLED: 4,
};
